import { Table } from 'antd'

import { emptyCharacter } from '../../../../components/EmptyChar'
import { renderCoupon, renderPrincipal } from '../../../../components/tables/table-column-renderers'
import {
  buildSearchFilterProps,
  sortBooleanColumn,
  sortNumericColumn,
  sortStringColumn,
} from '../../../../components/tables/utils'
import { renderIsCompliant } from '../IsCompliant'
import { IssuerCompliance } from './models'

export const buildIssuerCompliancesTableColumns = () => [
  {
    title: 'Banking Group',
    dataIndex: 'bankingGroupId',
    sorter: sortNumericColumn({ dataIndex: 'bankingGroupId' }),
    ...buildSearchFilterProps({ dataIndex: 'bankingGroupId' }),
  },
  {
    title: 'Code',
    dataIndex: 'code',
    sorter: sortStringColumn({ dataIndex: 'code' }),
    ...buildSearchFilterProps({ dataIndex: 'code' }),
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: sortStringColumn({ dataIndex: 'name' }),
    ...buildSearchFilterProps({ dataIndex: 'name' }),
  },
  {
    title: 'Invested ($)',
    dataIndex: 'amountInvested',
    render: renderPrincipal,
    sorter: sortNumericColumn({ dataIndex: 'amountInvested' }),
  },
  {
    title: 'Is Compliant',
    dataIndex: 'isCompliant',
    render: renderIsCompliant,
    sorter: sortBooleanColumn({ dataIndex: 'isCompliant' }),
  },
  {
    title: 'Trades',
    dataIndex: 'tradesCount',
    sorter: sortNumericColumn({ dataIndex: 'tradesCount' }),
  },
]

export const buildShortAndLongCompliancesColumns = (compliance: IssuerCompliance) => {
  const issuerCompliancesInnerItems = [
    { ...compliance.long, complianceType: 'Long', key: `${compliance.code}-long` },
    { ...compliance.short, complianceType: 'Short', Key: `${compliance.code}-short` },
  ]

  const issuerCompliancesInnerColumns = [
    { title: 'Type', dataIndex: 'complianceType' },
    { title: 'Amount ($)', dataIndex: 'amountInvested', render: renderPrincipal },
    { title: 'Max Limit (%)', dataIndex: 'maxLimitPct', render: renderCoupon },
    { title: 'Max Money ($)', dataIndex: 'maxMoneyLimit', render: renderPrincipal },
    { title: 'Rating', dataIndex: 'rating', render: renderCoupon },
    { title: 'Trades', dataIndex: 'tradesCount' },
    { title: 'Available ($)', dataIndex: 'amountAvailable', render: renderPrincipal },
    { title: 'Share', dataIndex: 'investmentSharePct', render: renderPrincipal },
    { title: 'Is Compliant', dataIndex: 'isCompliant', render: renderIsCompliant },
    { title: 'Break Reason', dataIndex: 'breakReason', render: (reason: string) => (reason ? reason : emptyCharacter) },
  ]

  return (
    <Table
      columns={issuerCompliancesInnerColumns}
      dataSource={issuerCompliancesInnerItems}
      pagination={false}
      rowKey="key"
      bordered
    />
  )
}
